import { createContext, useState, useContext, useEffect, ReactNode } from "react";
import { AuthData, AuthUser } from "../models/auth.model";

interface AuthContextType {
  user: AuthUser | null;
  logOut: () => void;
  hasAnyRole: (requiredRoles: string[]) => boolean;
}

interface AuthProviderProps {
  children: ReactNode;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [auth, setAuth] = useState<AuthData | null>();

  const hasAnyRole = (requiredRoles: string[]) => {
    return requiredRoles.includes(auth?.user?.role ?? "");
  };

  const logOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    console.log('auth ull 1');
    setAuth(null);
    window.location.replace("/sign-in");
  };

  useEffect(() => {
    const updateAuthFromLocalStorage = () => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user) as AuthUser;
        setAuth({ user: parsedUser });
      } else {
        console.log('auth ull');
        
        setAuth(null);
      }
    };

    updateAuthFromLocalStorage();

    window.addEventListener("storage", updateAuthFromLocalStorage);

    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      console.log(value);
      
      // to do
      // eslint-disable-next-line prefer-rest-params
      originalSetItem.apply(this, arguments as any);
      if (key === "user") {
        updateAuthFromLocalStorage();
      }
    };

    return () => {
      window.removeEventListener("storage", updateAuthFromLocalStorage);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user: auth?.user ?? JSON.parse(localStorage.getItem("user")) as AuthUser, logOut, hasAnyRole }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
